import './dashboardStakeHolder.css'
import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import userIcon from "../../../images/userIcon.png";
import { Container, Divider, Grid, Paper } from "@mui/material";
import { GET_STAKEHOLDER_CATEGORY, GET_APP_COUNT_STAKE, GET_USER_DETAILS, GET_STAKEHOLDER_BY_URN, GET_WORKFLOW_REQUEST, GET_SUBMITTED_REQUEST_LIST, WORKFLOW_ACTION_TAKEN, GET_GROWER_BY_URN, GET_INVOICE_PAYMENTS_BY_URN, GET_STAKEHOLDER_DASHBOARD_PO_DETAILS, CURRENT_RATE } from '../../../common/URLs';
import { useNavigate } from "react-router-dom";
import jwt from 'jwt-decode';

import { loaderService } from '../../../common/custom-loader/loader-service';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Row, Col, Stack, Table } from 'react-bootstrap';

import Typography from '@mui/material/Typography';
import { onSignOut } from '../../../common/Utils';
import { updateStakeholderADB2CId } from '../../../common/Utils'
import { MODULE_ACCESS } from '../../../common/constants';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { PROD } from '../../../common/constants';
import { t } from 'i18next';
import apiClient from '../../../axios';
export let stakeHolderCategory = '';
export let appCountDisplay;
function DashboardStakeHolder() {
  const navigate = useNavigate();
  const decoded = jwt(getLocalStorageItem('id_token'));
  const [selected, setSelected] = useState("Dashboard");
  const [stakeHolderType, setStakeHolderType] = useState("");
  const [stakeHolderSubCategory, setStakeHolderSubCategory] = useState("");
  const [stakeholderURN, setStakeholderURN] = useState();
  const [stakeDetails, setStakeDetails] = useState();
  const [appCount, setAppCount] = useState();
  const [getallworkflowdata, setgetallworkflowdata] = useState();
  const [sentworkflowdata, setSentworkflowdata] = useState();
  const [actionTakenData, setActionTakenData] = useState();
  const [totalLandAreaSummary, setTotalLandAreaSummary] = useState({
    existing: 0,
    available: 0,
    total: 0,
    unit: ''
  });
  const [invoiceDetails, setInvoiceDetails] = useState();
  const [poDetails, setPoDetails] = useState();
  const [currentRate, setCurrentRate] = useState();

  const ColorButton = styled(Button)(() => ({
    width: 150,
    color: '#FFFFFF',
    backgroundColor: '#005BAA',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      color: '#005BAA',
    },
    '&:active': {
      backgroundColor: '#FFFFFF',
      color: '#005BAA',
    }
  }));

  useEffect(() => {
    getAllWorkFlow();
    getSentWorkFlow();
    actionTakenWorkFlow();
    getInvoicePayments();
    getCurrentRate();
  }, []);

  useEffect(() => {
    if (getLocalStorageItem('id_token')) {
      if (decoded.extension_URN) {
        loaderService.showLoader();
        apiClient.post(GET_STAKEHOLDER_CATEGORY,
          {
            "urn": decoded.extension_URN,
          },
          {
            headers: {
              Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
            }
          }
        )
          .then((response) => {
            loaderService.hideLoader();
            setStakeHolderSubCategory(response.data.subCategory);
            if (response && response.data) {
              setStakeHolderType(response.data.category == "TemporaryStorage" ? "Interim Storage Operator" : response.data.category);
              setStakeHolderSubCategory(response.data.subCategory);
              stakeHolderCategory = response.data.category == "TemporaryStorage" ? "Interim Storage Operator" : response.data.category;
              setStakeholderURN(response.data.urn);
            }
          })
          .catch(function (error) {
            console.log(error);
            loaderService.hideLoader();
          });
      }
    }
  }, [getLocalStorageItem('id_token')]);

  useEffect(() => {
    if (stakeholderURN) {
      getStakeDetails();
      getStakeholderDashboardPOdetails();
    }
  }, [stakeholderURN]);

  function getStakeDetails() {
    apiClient
      .post(GET_STAKEHOLDER_BY_URN,
        {
          "urn": stakeholderURN,
          "type": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStakeDetails(response.data);
        if (!response.data?.stakeHolder?.adb2cOid && decoded.extension_URN) {
          updateStakeholderADB2CId(decoded.extension_URN, decoded.oid);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    if (stakeDetails) {
      getAppCountStake();
    }
  }, [stakeDetails]);

  function getAppCountStake() {
    apiClient
      .post(GET_APP_COUNT_STAKE,
        {
          "userID": stakeDetails?.stakeHolder?.id,
          "isStakeHolder": true
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setAppCount(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  appCountDisplay = appCount?.applicationStatuses?.[0]?.count;
  //  useEffect(() => {
  //   if (appCountDisplay) {
  //     appCountDisplayexport = appCountDisplay;
  //   }
  // }, [appCountDisplay]);
  const onClickRegistrationDetails = () => {
    setSelected("Registration")
    if (stakeHolderType == "Transporter") {
      navigate("/registrationDetailsTransporter")
    } else if (stakeHolderSubCategory == "Grower" || stakeHolderSubCategory == "Individual" || stakeHolderSubCategory == "JFMC" || stakeHolderSubCategory === "Other Agency") {
      navigate("/registrationDetails", { state: { URN: decoded.extension_URN, appCountDisplay: appCountDisplay } });
    } else if (stakeHolderType == "HIT") {
      navigate("/registrationDetailsHit");
    } else if (stakeHolderType == "LLE") {
      navigate("/registrationdetailsLle")
    } else if (stakeHolderType == "Interim Storage Operator") {
      navigate("/registrationDetailsTempStorage", { state: { isPreReg: false } })
    } else if (stakeHolderSubCategory == "Forest") {
      navigate("/registrationDetailsForest", { state: { URN: decoded.extension_URN, appCountDisplay: appCountDisplay } })
    } else if (stakeHolderSubCategory === "Co-operative" || stakeHolderSubCategory === "FPO" || stakeHolderSubCategory === "SHG" || stakeHolderSubCategory === "FPC") {
      navigate("/registrationMemberDetails", { state: { URN: decoded.extension_URN, stakeHolderSubCategory: stakeHolderSubCategory, appCountDisplay: appCountDisplay } })
    }
  }

  const onPaymentStatus = () => {
    navigate("/paymentDashboard/PaymentStatusStakeholderUser");
  }

  function getAllWorkFlow() {
    loaderService.showLoader();
    apiClient
      .post(GET_WORKFLOW_REQUEST,
        {
          "userRole": null
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setgetallworkflowdata(response.data);
        loaderService.hideLoader();

      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  function getSentWorkFlow() {
    loaderService.showLoader();
    apiClient
      .post(GET_SUBMITTED_REQUEST_LIST,
        {

        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setSentworkflowdata(response.data);
        loaderService.hideLoader();

      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  function actionTakenWorkFlow() {
    loaderService.showLoader();
    apiClient
      .post(WORKFLOW_ACTION_TAKEN,
        {
          "userRole": null
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setActionTakenData(response.data);
        loaderService.hideLoader();

      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }


  function onComment(e) {
    e.preventDefault();
    const userDatastake = {
      "urn": stakeholderURN,
      "submitClarificationstake": "yes",
      "stakeRole": "Stakeholder"

    }

    if (appCountDisplay === 0) {

    }
    else {
      (stakeHolderSubCategory == "Individual" || stakeHolderSubCategory == "JFMC" || stakeHolderSubCategory === "Other Agency") ? navigate("/dashboardHome/registrationDetails", { state: { data: userDatastake } }) : navigate("/dashboardHome/dashboardStakeHolder/stakeclarification", { state: { data: userDatastake } });
    }
  }

  function getInvoicePayments() {
    loaderService.showLoader();
    apiClient
      .post(GET_INVOICE_PAYMENTS_BY_URN,
        {
          "urn": decoded.extension_URN,
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        loaderService.hideLoader();
        setInvoiceDetails(response.data.invoicePayments);
      })
      .catch(function (error) {
        loaderService.hideLoader();
        console.log(error);
      });
  }

  function getCurrentRate() {
    loaderService.showLoader();
    apiClient
      .post(CURRENT_RATE,
        {
          "urnNumber": decoded.extension_URN,
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        loaderService.hideLoader();
        setCurrentRate(response.data);
      })
      .catch(function (error) {
        loaderService.hideLoader();
        console.log(error);
      });
  }

    const getTotalByStatus = (invoices, status) => {
        if (status == "InvoiceReceived") {
            return invoices
                ?.reduce((sum, inv) => sum + parseFloat(inv.totalInvoiceAmount || 0), 0);
        }
        else {
            return invoices
                ?.filter(inv => inv.status === status)
                ?.reduce((sum, inv) => sum + parseFloat(inv.totalInvoiceAmount || 0), 0);
        }
  };

  const totalInvoiceGenerated = getTotalByStatus(invoiceDetails, "InvoiceReceived");
  const totalInvoicePaid = getTotalByStatus(invoiceDetails, "Paid");
  const paymentUnderProcess = getTotalByStatus(invoiceDetails, "Payment_Under_Process");

  const formatCurrency = val => `₹${val?.toLocaleString("en-IN")}`;

  useEffect(() => {
    const conversionToSqFt = {
      'sq ft': 1,
      'pura': 900,
      'katha': 2880,
      'bigha': 14400,
      'acre': 43560,
      'hectare': 107639
    };

    const extractValueAndUnit = str => {
      const match = str.trim().match(/^([\d.]+)\s*(.*)$/);
      if (!match) return { value: 0, unit: '' };
      return {
        value: parseFloat(match[1]),
        unit: match[2].toLowerCase()
      };
    };

    const getLowestUnit = units => {
      const order = ['sq ft', 'pura', 'katha', 'bigha', 'acre', 'hectare'];
      for (let u of order) {
        if (units.includes(u)) return u;
      }
      return 'sq ft';
    };

    const growerMasters = stakeDetails?.stakeHolder?.growerMasters || [];
 
const activeLandAreas = [];
const availableLandAreas = [];
 
growerMasters.forEach((master) => {
  if (master?.growerType !== "Individual") {
    // Use growerCoopLandDetails if growerType exists
    const coopLandDetails = master?.growerMemberDetails?.flatMap(m => m?.growerCoopLandDetails || []) || [];
 
    coopLandDetails.forEach((detail) => {
      if (detail?.isActive === 1) {
        if (detail?.landArea) {
          activeLandAreas.push(extractValueAndUnit(detail.landArea));
        }
        if (detail?.availableLandArea) {
          availableLandAreas.push(extractValueAndUnit(detail.availableLandArea));
        }
      }
    });
 
  } else {
    // Fallback to growerLandDetails
    (master?.growerLandDetails || []).forEach((detail) => {
      if (detail?.isActive === 1) {
        if (detail?.landArea) {
          activeLandAreas.push(extractValueAndUnit(detail.landArea));
        }
        if (detail?.availableLandArea) {
          availableLandAreas.push(extractValueAndUnit(detail.availableLandArea));
        }
      }
    });
  }
});
 
// Gather all units and determine if conversion is needed
const allUnits = [
...activeLandAreas.map(a => a.unit),
...availableLandAreas.map(a => a.unit)
];
 
const uniqueUnits = [...new Set(allUnits)];
const finalUnit = uniqueUnits.length === 1 ? uniqueUnits[0] : 'sq ft';
 
// Convert values to final unit
const convertTo = (arr, unit) => {
  return arr.reduce((sum, item) => {
    const sqft = item.value * (conversionToSqFt[item.unit] || 0);
    return unit === 'sq ft' ? sum + sqft : sum + item.value;
  }, 0);
};
 
const existing = convertTo(activeLandAreas, finalUnit);
const available = convertTo(availableLandAreas, finalUnit);
const total = existing + available;
 
// Update state
setTotalLandAreaSummary({
  existing,
  available,
  total,
  unit: finalUnit
});
  }, [stakeDetails]);

  const DataRow = ({ label, value, highlight = false, isLink = false, onClick }) => (
    <Grid item xs={12} sm={6} md={4}>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>

      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: highlight ? 'bold' : 'normal',
          color: 'primary.main',
          cursor: isLink ? 'pointer' : 'default',
          textDecoration: isLink ? 'underline' : 'none',
          display: 'inline-block'
        }}
        onClick={isLink ? onClick : undefined}
      >
        {value}
      </Typography>
    </Grid>
  );

  function getStakeholderDashboardPOdetails() {
    loaderService.showLoader();
    apiClient
      .post(GET_STAKEHOLDER_DASHBOARD_PO_DETAILS,
        {
          "stakeholderType": stakeHolderType,
          "stakeholderUrn": stakeholderURN
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        loaderService.hideLoader();
        if (stakeHolderType === "HIT") {
          setPoDetails(response.data.hITPODetails)
        }
        else setPoDetails(response.data);
      })
      .catch(function (error) {
        loaderService.hideLoader();
        console.log(error);
      });
  }

  let currentRateDisplay = "";

  if (currentRate?.[0]?.category === "Grower") {
    // Flatten all growerLandDetails
    const growerLandDetails = stakeDetails?.stakeHolder?.growerMasters?.flatMap(
      master => master.growerLandDetails || []
    );

    // Map through all grower currentRate
    const rateBlocks = currentRate?.map(item => {
      const matchedLand = growerLandDetails?.find(
        land => land.id === item.landId
      );
      const landName = matchedLand?.landName || "";
      return `Land: ${landName} (Rate: ₹${item.itemRate})`;
    });

    // Join them with JSX line breaks
    currentRateDisplay = (
      <>
        {rateBlocks.map((line, i) => (
          <div key={i}>{line}</div>
        ))}
      </>
    );
  } else {
    // For Transporter or others
    const rate = currentRate?.[0]?.itemRate;
    currentRateDisplay = rate && rate !== "N/A"
      ? `₹${rate}`
      : `N/A`;
  }

const displayName = [stakeDetails?.stakeHolder?.contactPersonFirstname, stakeDetails?.stakeHolder?.contactPersonMiddlename, stakeDetails?.stakeHolder?.contactPersonLastname]

  const data = {
    name: stakeDetails?.stakeHolder?.growerMasters[0]?.growerType === "Individual" ? displayName?.filter(part => part).join(' ') :  stakeDetails?.stakeHolder?.name,
    urn: stakeDetails?.stakeHolder?.urn,
    totalQuantity: stakeDetails?.stakeHolder?.growerMasters[0]?.totalQuantity,
    committedQuantity: stakeDetails?.stakeHolder?.growerMasters[0]?.committedQuantity,

    totalPOQuantity: stakeHolderType === "HIT" ? (
      <>
        Harvester: {poDetails?.harvesterPoQuantity}
        <br />
        Transporter: {poDetails?.transporterPoQuantity}
      </>
    ) : poDetails?.poQuantity,


    totalReceivedQuantity: stakeHolderType === "HIT" ? (
      <>
        Harvester: {poDetails?.harvesterGrnQuantity}
        <br />
        Transporter: {poDetails?.transporterGrnQuantity}
      </>
    ) : poDetails?.grnQuantity,


    totalBalanceQuantity: stakeHolderType === "HIT" ? (
      <>
        Harvester: {poDetails?.harvesterPoBalanceQuantity}
        <br />
        Transporter: {poDetails?.transporterPoBalanceQuantity}
      </>
    ) : poDetails?.poBalanceQuantity,


    totalLandArea: `${totalLandAreaSummary?.total?.toFixed(2)} ${totalLandAreaSummary?.unit}`,
    availableLandArea: `${totalLandAreaSummary?.available?.toFixed(2)} ${totalLandAreaSummary?.unit}`,
    currentRate: currentRateDisplay,
    totalInvoiceGenerated: formatCurrency(totalInvoiceGenerated),
    totalInvoicePaid: formatCurrency(totalInvoicePaid),
    paymentUnderProcess: formatCurrency(paymentUnderProcess),
    // pendingClarificationFromScru: appCountDisplay,
    // actionTaken: actionTakenData?.length,
    // pendingClarificationFromResScru: getallworkflowdata?.length,
    // requestSentforApproval: sentworkflowdata?.length

  };


  return (
    <Container maxWidth="xxl">
      <Grid container >
        <Grid item xs={12}>
          <Typography variant="h5" gutterBottom>{t('dashboardStakeholder.welcomeToStakeholderDashboard')}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
            <Grid container spacing={4}>
              <DataRow label="Name" value={data.name} highlight />
              <DataRow label="URN" value={data.urn} highlight />
            </Grid>
            <Grid container spacing={3} mt={1}>
              {stakeHolderType === "Grower" &&
                <>
                  <DataRow label="Total Quantity (MT)" value={data.totalQuantity} highlight />
                  <DataRow label="Committed Quantity (MT)" value={data.committedQuantity} highlight />
                  <DataRow label="Total Land Area" value={data.totalLandArea} highlight />
                  <DataRow label="Available Land Area" value={data.availableLandArea} highlight />
                </>
              }
              <DataRow label="Total PO Quantity (MT)" value={data.totalPOQuantity} highlight />
              <DataRow label={stakeHolderType === "Grower" || stakeHolderType === "Transporter" || stakeHolderType === "HIT" ? "Delivered Quantity (MT)" : stakeHolderType === "LLE" ? "Dispatch Quantity (MT)" : "Total Received Quantity (MT)"} value={data.totalReceivedQuantity} highlight />
              <DataRow label="Total Balance Quantity (MT)" value={data.totalBalanceQuantity} highlight />
              <DataRow label="Current Rate (per MT)" value={data.currentRate} highlight />
              <DataRow label="Total Invoice Generated (₹)" value={data.totalInvoiceGenerated} highlight />
              <DataRow label="Total Invoice Paid (₹)" value={data.totalInvoicePaid} highlight />
              <DataRow label="Payment under Process (₹)" value={data.paymentUnderProcess} highlight />
              {/* <Divider sx={{ width: '100%', my: 1 }} />
              <DataRow isLink label={t("dashboardStakeholder.pendingClarificationFromScru")} value={data.pendingClarificationFromScru} highlight onClick={(e) => onComment(e)} />
              <DataRow isLink label={t("dashboardStakeholder.pendingClarificationFromResScru")} value={data.pendingClarificationFromResScru} highlight onClick={() => (navigate('/dashboardHome/dashboardStakeHolder/allWorkList', { state: { type: "all" } }))} /> */}

              {/* <DataRow isLink label={t("dashboardStakeholder.requestSentforApproval")} value={data.requestSentforApproval} highlight onClick={() => (navigate('/dashboardHome/dashboardStakeHolder/sentForApproval', { state: { type: "sent" } }))} />
              <DataRow isLink label={t("dashboardStakeholder.actionTaken")} value={data.actionTaken} highlight onClick={() => (navigate('/dashboardHome/dashboardStakeHolder/actionTaken', { state: { type: "actionTaken" } }))} /> */}

            </Grid>
          </Paper>
          {/* <div>
            <Container fluid>
              {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG16</p>}
              <Row>
                <Col xs={12} md={12}>
                  <p className='lead_header_text'>{t('dashboardStakeholder.welcomeToStakeholderDashboard')}</p>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={4}>
                  <a href="#" onClick={(e) => onComment(e)} style={{ textDecoration: "none" }}>
                    <div className='lead_card' style={{ height: "22vh" }}>
                      <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{appCountDisplay}</Typography>

                      <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>{t("dashboardStakeholder.pendingClarificationFromScru")}</Typography>
                    </div></a>
                </Col>
                <Col xs={12} md={4}>

                  <div className='lead_card' style={{ height: "22vh" }} onClick={() => (navigate('/dashboardHome/dashboardStakeHolder/actionTaken', { state: { type: "actionTaken" } }))}>
                    <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{actionTakenData?.length}</Typography>
                    <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>{t("dashboardStakeholder.actionTaken")}</Typography>
                  </div>
                </Col>
                <Col xs={12} md={4}>
                  <div className='lead_card' style={{ height: "22vh" }} onClick={() => (navigate('/dashboardHome/dashboardStakeHolder/allWorkList', { state: { type: "all" } }))}>
                    <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{getallworkflowdata?.length}</Typography>

                    <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>{t("dashboardStakeholder.pendingClarificationFromResScru")}</Typography>
                  </div></Col>
                <Col xs={12} md={4}>
                  <div className='lead_card' style={{ height: "22vh" }} onClick={() => (navigate('/dashboardHome/dashboardStakeHolder/sentForApproval', { state: { type: "sent" } }))}>
                    <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{sentworkflowdata?.length}</Typography>
                    <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>{t("dashboardStakeholder.requestSentforApproval")}</Typography>
                  </div></Col>
              </Row>
            </Container>
          </div> */}

        </Grid>
      </Grid>
    </Container>
  );
}
export default DashboardStakeHolder;